import { FC, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AnnouncementIcon from '../../../../../../../../assets/icons/announcement.svg?react';
import RouteConstants from '@/features/router/RouteConstants';
import { CongratulationScreen } from '@/global/components/CongratulationScreen';

export const CongratulationStep: FC = () => {
  const history = useHistory();

  const handleCreateNewCampaign = () => {
    history.replace(RouteConstants.createCampaign);
  };

  const handleCloseClick = () => {
    history.replace(RouteConstants.home);
  };

  useEffect(() => {
    const campaignSection = document.getElementById('campaign-summary-section');
    if (campaignSection) {
      campaignSection.querySelectorAll('header').forEach((header) => {
        const button = header.querySelector('button');
        if (button) {
          button.classList.add('pointer-events-none');
        }
      });
    }
  }, []);

  return (
    <CongratulationScreen
      title='campaign.campaignCreatedSuccesfully'
      subtitle='campaign.readyToCreateAnotherCampaign'
      secondaryButton={{
        icon: <AnnouncementIcon className='!text-brand-600' />,
        text: 'campaign.createAnotherCampaign',
        onClick: handleCreateNewCampaign,
      }}
      primaryButton={{
        text: 'COMMON.close',
        onClick: handleCloseClick,
      }}
      showHeader
    />
  );
};
